export const POLL_INTERVAL = 10000;
export const UNAVAILABLE_RESOURCE_CODE = 503;
export const MAINTENANCE_MODE_EVENT = 'maintenanceMode';
